
import Vue from "vue";
import {parseIntWithDefault} from "kistenkonfigurator/build/util/util";
import * as BusinessLogic from "../../model/ProductBusinessLogic";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {CartItemMutation, ProductItem} from "../../model/cart/LocalCartItem";
import AddToCartIcon from "./AddToCartIcon.vue";

interface State {
  quantity: string;
}

export default Vue.extend({
  components: {
    AddToCartIcon,
  },
  inject: ["generateProductImage"],
  props: {
    product: {
      type: Object,
      default() {
        return ProductModelFactory.createEmptyOverviewProduct();
      },
    },
    configuration: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Number,
      default: 1,
    },
    productImageUrl: {
      type: String,
      default: () => "",
      required: false,
    },
    showAddToCartBtn: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data(): State {
    return {
      quantity: "1",
    };
  },
  watch: {
    quantity() {
      this.$emit("input", parseIntWithDefault(this.quantity, 1));
    },
    value() {
      this.quantity = this.value.toString();
    },
  },
  methods: {
    getQuantityAsInt(): number {
      return parseIntWithDefault(this.quantity, 1);
    },
    format(value: any) {
      const parsedValue = parseIntWithDefault(value, 1);
      return Math.min(2000, Math.max(1, parsedValue));
    },
    async addToCart() {
      const userConfig = this.configuration;
      const modifiedProduct = BusinessLogic.applyConfigurationToProduct(this.product, userConfig);

      // @ts-ignore
      const productImage = await this.generateProductImage();

      const item: ProductItem = {
        configuration: userConfig,
        quantity: this.getQuantityAsInt(),
        product: modifiedProduct,
        productImageUrl: productImage,
        mutability: CartItemMutation.ALL,
      };
      await this.$bl.cartService.getCartModel().addItem([item]);
      (this as any).$toast.success(`Zum Warenkorb hinzugefügt ${this.product.name}`);
    },
  },
});
